import adminRoutes from "./admin"
import privateRoutes from "./private"
import publicRoutes from "./public"
import { type Route, renameKeys, arrayToObject } from "./utils"

const routes = {
	public: publicRoutes,
	private: privateRoutes,
	admin: adminRoutes,
	external: {
		relative: (relative: string) => {
			const IS_PROD = process.env.NODE_ENV === "production"
			const pathname = relative.startsWith("/")
				? relative.substring(1)
				: relative

			return IS_PROD
				? `https://www.gretaspatchwork.com/${pathname}`
				: `http://localhost:3101/${pathname}`
		},
		instagram: `https://www.instagram.com/gretaspatchwork?igsh=MXBpc3Zmd3J2NmZ0bQ==`,
	},
}

export const protectedRoutes = Object.values<Route>(
	arrayToObject(
		Object.entries(routes).map(entry => ({
			...renameKeys(entry[1], entry[0]),
		})),
	),
).filter(route => route.isProtected)

export default routes
